<template>
  <span>
    <i :class="[ getClass, horizontalAlign ? 'vh-align' : '', padding ? 'p-1' : '' ]"></i>
  </span>
</template>

<script>
export default {
  props: {
    faClass: {
      type: String
    },
    horizontalAlign: {
      default: false
    },
    solid: {
      type: Boolean,
      default: true
    },
    padding: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getClass () {
      let fa = this.solid ? 'fas' : 'far'
      return fa + ' fa-' + this.faClass
    }
  }
}
</script>
